import { scrollToAnchor } from '../helper/helper.js';

export default class Nav {
  constructor() {
    this.navTrigger = document.getElementById('js-nav_trigger');

    if (this.navTrigger !== null) {
      this.bodyTag = document.querySelector('body');
      this.header = document.querySelector('.l-header');
      this.hamburger = document.querySelector('.o-hamburger');
      this.nav = document.querySelector('.l-nav');

      this.activeClass = 'is-active';
      this.navFlag = false;
      this.navTarget = [...document.querySelectorAll('.js-nav_target')];

      this.navFocusBlock = document.querySelector('.l-nav__item_list');

      this.init();
    }
  }

  init() {
    this.navToggle();

    this.navAnchorLinks();
    this.markCurrentPage();
  }

  markCurrentPage() {
    const main = document.getElementById('js-main');
    const currentPage = main?.dataset.page;

    if (!currentPage) return;

    const headerTriggers = document.querySelectorAll('.js-header-trigger');
    const footerTriggers = document.querySelectorAll('.js-footer-trigger');

    headerTriggers.forEach(trigger => {
      const targetMenu = trigger.dataset.menu;
      if (!targetMenu) return;

      // 前方一致
      if (currentPage.startsWith(targetMenu)) {
        trigger.classList.add('is-active');
      }
    });
     footerTriggers.forEach(trigger => {
      const targetMenu = trigger.dataset.menu;
      if (!targetMenu) return;

      // 完全一致
      if (currentPage === (targetMenu)) {
        trigger.classList.add('is-active');
      }
    });
  }

  navToggle() {
    this.navTrigger.addEventListener('click', () => {
      if (this.navFlag) {
        this.navClose();
      } else {
        this.navOpen();
      }
    });
  }

  navOpen() {
    this.navTarget.forEach(el => {
      el.classList.add(this.activeClass);
      if (el.getAttribute('aria-hidden') === 'true') {
        el.setAttribute('aria-hidden', 'false');
      }
    });

    this.bodyFixed();

    this.navTrigger.setAttribute('aria-expanded', 'true');
    this.navFlag = true;

    this.header.classList.add('nav-opened');
    this.hamburger.classList.add('nav-opened');
  }

  navClose() {
    this.navTarget.forEach(el => {
      el.classList.remove(this.activeClass);
      if (el.getAttribute('aria-hidden') === 'false') {
        el.setAttribute('aria-hidden', 'true');
      }
    });

    this.bodyStatic();

    this.navTrigger.setAttribute('aria-expanded', 'false');
    this.navFlag = false;

    this.header.classList.remove('nav-opened');
    this.hamburger.classList.remove('nav-opened');
  }

  navAnchorLinks() {
    const anchorLinks = this.nav.querySelectorAll('a[href*="#"]');

    anchorLinks.forEach(link => {
      link.addEventListener('click', event => {
        const href = link.getAttribute('href');
        
        // アンカー部分だけを抽出（#以降）
        const hashIndex = href.indexOf('#');
        if (hashIndex === -1) return;

        const targetId = href.slice(hashIndex + 1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          event.preventDefault();
          this.navClose();

          setTimeout(() => {
            scrollToAnchor(targetId);
          }, 300);
        }

      });
    });
  }


  bodyFixed() {
    this.currentY = window.scrollY;
    this.bodyTag.style.position = 'fixed';
    this.bodyTag.style.top = -this.currentY + 'px';
    this.bodyTag.style.width = '100%'; // 横スクロール抑止
  }

  bodyStatic() {
    this.bodyTag.style.position = '';
    this.bodyTag.style.top = '';
    this.bodyTag.style.width = '';
    window.scrollTo(0, this.currentY);
  }
  
}
